(async () => {
	const debugMode = 1,
		testId = "GLX-020",
		logInfo = testId + " -->",
		variation = 2;

	try {
		// Avoid code to run multiple times
		if (!document.documentElement.classList.contains(`${testId}_var_${variation}`)) {
			document.documentElement.classList.add(`${testId}_var_${variation}`);
			document.documentElement.classList.add(`${testId}_var`);

			// Tampermonkey has a specific window scope. This will make sure you access the correct website's "window" object.
			let _window = window;
			if (typeof unsafeWindow !== "undefined") _window = unsafeWindow;

			_window._conv_q = _window._conv_q || [];

			// Wait for the main content wrapper
			const waitForElement = (selector) => {
				try {
					return new Promise((resolve) => {
						try {
							if (document.querySelector(selector)) {
								resolve(document.querySelector(selector));
								return;
							}

							const observer = new MutationObserver(() => {
								try {
									if (document.querySelector(selector)) {
										observer.disconnect();
										resolve(document.querySelector(selector));
									}
								} catch (err) {
									if (debugMode) console.error(logInfo, err.message);
								}
							});

							observer.observe(document.documentElement, {
								childList: true,
								subtree: true
							});
						} catch (err) {
							if (debugMode) console.error(logInfo, err.message);
						}
					});
				} catch (err) {
					if (debugMode) console.error(logInfo, err.message);
				}
			};

			// Wait for an element(s) to be fully loaded in the DOM
			const sentConvertEvent = (number, label = "") => {
				try {
					_conv_q.push(["triggerConversion", number]);

					if (debugMode) console.log(logInfo, "Convert event sent:", number, label);
				} catch (err) {
					if (debugMode) console.error(logInfo, err.message);
				}
			};

			const sendGAEvent = (category) => {
				try {
					let _category = `hd_${category.toLowerCase().trim().replace(/ /gi, "_")}`;

					_window.gtag("event", _category, {
						send_to: "G-2FT1FSRP5J"
					});

					if (debugMode) console.log(logInfo, "Sent GA event:", _category);
				} catch (err) {
					if (debugMode) console.error(logInfo, err.message);
				}
			};

			waitForElement(".product-info__block-item variant-inventory").then((inventoryEl) => {
				// Create parent div for flex layout
				const flexContainer = document.createElement("div");
				flexContainer.classList.add("GLX-020__inventory-container");

				// Move existing inventory span into container
				const inventorySpan = inventoryEl.querySelector("span");
				flexContainer.appendChild(inventorySpan);

				// Create and add sellout risk span
				const selloutSpan = document.createElement("span");
				selloutSpan.innerHTML = `<svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M8.5 3.5V8L11.5 9.5M16 8C16 12.1421 12.6421 15.5 8.5 15.5C4.35786 15.5 1 12.1421 1 8C1 3.85786 4.35786 0.5 8.5 0.5C12.6421 0.5 16 3.85786 16 8Z" stroke="#317A08" stroke-linecap="round" stroke-linejoin="round"/> </svg> Limited stock`;
				selloutSpan.classList.add("GLX-020__sellout-risk");
				flexContainer.appendChild(selloutSpan);

				inventoryEl.insertAdjacentElement("afterbegin", flexContainer);
			});
		}
	} catch (err) {
		if (debugMode) console.error(logInfo, err.message);
	}
})();